(() => {
  // Texte in der Sprache der Seite: window.cmT.price_mode aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt price_mode).
  // Fehlt cmT oder ein Schlüssel, gilt der deutsche Text hier.
  const cmTexts = (window.cmT && window.cmT.price_mode) || {};
  const tx = (key, de) => {
    const own = cmTexts[key];
    return typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
  };
  const root = document.documentElement;
  const key = 'compumac-price-mode';
  // Netto-Ansicht nur für angemeldete, freigeschaltete Geschäftskunden (data-cm-b2b aus layout/theme.liquid,
  // gesetzt nur mit Kundenpreisen aus CompuHub). Alle anderen sehen immer den Gesamtpreis inkl. MwSt. als Hauptpreis
  // (§ 3 Abs. 3 PAngV; OFFEN A 15, Shop-Texte 1 „Netto-Ansicht“).
  const eligible = root.dataset.cmNetEligible === 'true' && root.dataset.cmB2b === 'true';
  const setMode = (requested, announce = false) => {
    const mode = eligible && requested === 'net' ? 'net' : 'gross';
    root.dataset.cmPriceMode = mode;
    document.querySelectorAll('[data-cm-price-toggle]').forEach(control => {
      control.hidden = !eligible;
      control.querySelectorAll('[data-cm-price-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cmPriceMode === mode)));
      if (announce) control.querySelector('[data-cm-price-status]').textContent = mode === 'net' ? tx('net', 'Nettopreise zuzüglich 19 Prozent Mehrwertsteuer. Gesamtpreise inklusive Mehrwertsteuer bleiben sichtbar.') : tx('gross', 'Bruttopreise inklusive Mehrwertsteuer.');
    });
    if (eligible) { try { sessionStorage.setItem(key, mode); } catch {} }
    document.dispatchEvent(new CustomEvent('cm:price-mode', {detail:{mode}}));
    return mode;
  };
  let remembered = root.dataset.cmPriceDefault || 'gross';
  try { remembered = sessionStorage.getItem(key) || remembered; } catch {}
  setMode(remembered);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cm-price-mode]');
    if (button && button.closest('[data-cm-price-toggle]')) setMode(button.dataset.cmPriceMode, true);
  });
  document.addEventListener('shopify:section:load', () => setMode(root.dataset.cmPriceMode));
})();
